import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { DashboardItemEntity } from './dashboard-item.entity';

export interface IDashboardListExtra
	extends IListColumnConfig<DashboardItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IDashboardListEntity extends IListAttrs<DashboardItemEntity> {
	availableColumns: Map<string, IDashboardListExtra>;
}

const entityDefaults: IDashboardListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class DashboardListEntity
	implements
		IDashboardListEntity,
		IListOperations<DashboardListEntity, DashboardItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IDashboardListExtra>
	): DashboardListEntity {
		const instance = new DashboardListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IDashboardListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<DashboardItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, DashboardItemEntity>
	): DashboardListEntity {
		return produce(this, (draft: DashboardListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, dashItem) => {
			if (!dashItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...dashItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, dashItem) => {
			if (dashItem.updatedByAvatar && dashItem.updatedByAvatar?.name) {
				acc = acc.add(dashItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, dashItem) => {
			if (dashItem.createdByAvatar && dashItem.createdByAvatar.name) {
				acc = acc.add(dashItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
